export default function ($api) {
    return {
        /**
         * Получение фильтов категории
         * @param { String } sectionId
         * @param { Boolean } isBrand
         * @returns {*}
         */
        getAll(sectionId = "0", isBrand = false) {
            const path = isBrand ? "brand-filters" : "filters";
            return $api.get(`api/${path}/${sectionId}`);
        },
        /**
         * Применить фильтры категории
         * @param { String } sectionId
         * @param { String } filterCode
         * @param { Object } filters
         * @param { Boolean } isBrand
         * @returns {*}
         */
        apply({ sectionId = 0, filterCode = "", filters = {}, isBrand = false }) {
            const path = isBrand ? "brand-filters" : "filters";
            return $api.post(`api/${path}/${sectionId}`, { filterCode, filters }, true, true);
        },
    };
}
